export default __webpack_public_path__ + "static/media/Games-Room.0630c447.webp";